import { Box } from '@mui/material';

import useTitle from '@/hooks/useTitle';
import FavIconForm from '@/components/forms/tenants/administration/FavIconForm';
import LogoForm from '@/components/forms/tenants/administration/LogoForm';
import ThemeForm from '@/components/forms/tenants/administration/ThemeForm';

export default function Administration() {
  useTitle('Theme');

  return (
    <Box
      sx={{
        m: 2,
        display: 'flex',
        flexDirection: 'row',
        gap: 2,
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, flex: 1 }}>
        <FavIconForm />
        <LogoForm />
      </Box>

      <Box sx={{ minWidth: 250, flex: 4.5 }}>
        <ThemeForm />
      </Box>
    </Box>
  );
}
